import { ReactComponent as CollapseIcon } from "./side-nav-collapse-icon.svg";

const SideNavCollapseIcon: React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined;
  }
> = (props) => <CollapseIcon {...props} />;

export default SideNavCollapseIcon;
